(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[98289],{

/***/ 98289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Parkinson; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/bestrounduplawyers/parkinson/icons/Form.tsx


function Form() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        fill: "none",
        viewBox: "0 0 60 60",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_69",
                style: {
                    maskType: "alpha"
                },
                width: "60",
                height: "60",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H60V60H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_0_69)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#356E3F",
                    d: "M23.968 0v3.571h-4.613V10h21.29V3.57h-4.612V0H23.968zM8 6.428V60h44V6.428h-8.517v5c0 .749-.676 1.429-1.419 1.43H17.935c-.743-.001-1.419-.681-1.419-1.43v-5H8zm14.793 12.835a1.443 1.443 0 011.397.78 1.485 1.485 0 01-.222 1.608l-6.387 7.143c-.51.58-1.515.613-2.062.067l-3.548-3.572c-.546-.521-.552-1.492-.023-2.03.53-.54 1.494-.544 2.019 0l2.483 2.5 5.39-6.005c.238-.28.588-.46.953-.491zm4.236 4.308c.044-.003.089-.003.133 0h19.871c.75-.011 1.442.673 1.442 1.428 0 .755-.692 1.44-1.442 1.429h-19.87c-.744.035-1.452-.614-1.487-1.362-.035-.748.61-1.46 1.353-1.495zm-4.236 7.834a1.443 1.443 0 011.397.782 1.485 1.485 0 01-.222 1.607l-6.387 7.143c-.51.58-1.515.613-2.062.067l-3.548-3.572c-.546-.521-.552-1.492-.023-2.03.53-.54 1.494-.544 2.019 0l2.483 2.5 5.39-6.005c.238-.28.588-.46.953-.491zm4.236 4.309c.044-.002.089-.002.133 0h19.871c.75-.011 1.442.673 1.442 1.428 0 .755-.692 1.44-1.442 1.429h-19.87c-.744.035-1.452-.614-1.487-1.362-.035-.748.61-1.46 1.353-1.495zm-4.236 7.835a1.441 1.441 0 011.397.78 1.484 1.484 0 01-.222 1.608l-6.387 7.143c-.51.58-1.515.613-2.062.067l-3.548-3.572c-.546-.522-.552-1.492-.023-2.03.53-.54 1.494-.544 2.019 0l2.483 2.499 5.39-6.005c.238-.279.588-.459.953-.49zm4.236 4.307c.044-.002.089-.002.133 0h19.871c.75-.01 1.442.674 1.442 1.429s-.692 1.44-1.442 1.428h-19.87c-.744.036-1.452-.613-1.487-1.36-.035-.75.61-1.462 1.353-1.497z"
                })
            })
        ]
    });
}
/* harmony default export */ var icons_Form = (Form);

;// CONCATENATED MODULE: ./src/components/bestrounduplawyers/parkinson/icons/Free.tsx


function Slowness() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        fill: "none",
        viewBox: "0 0 60 60",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_72",
                style: {
                    maskType: "alpha"
                },
                width: "60",
                height: "60",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H60V60H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_0_72)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#356E3F",
                    fillRule: "evenodd",
                    d: "M42.72 35.463a2.284 2.284 0 002.281-2.282 2.284 2.284 0 00-2.28-2.28 2.284 2.284 0 00-2.281 2.28 2.284 2.284 0 002.28 2.282zm10.754 2.693H40.541l-4.434-4.974 4.434-4.975h12.933v9.95zm.463-12.724V14.094a1.39 1.39 0 00-1.388-1.388h-2.66V7.732a1.39 1.39 0 00-1.387-1.388h-6.466a1.387 1.387 0 100 2.776h5.079v3.586h-7.759c-.559 0-1.06.334-1.278.85-.18.43-16.212 39.093-15.955 39.482.258.389.69.62 1.156.62h29.27a1.39 1.39 0 001.388-1.388V40.933h.925a1.39 1.39 0 001.388-1.388V26.821a1.39 1.39 0 00-1.388-1.388l-.925-.001zM38.697 3.86a1.386 1.386 0 00-1.818.74l-20.94 49.723a1.378 1.378 0 00-.007 1.062 1.38 1.38 0 001.284.865c.56 0 1.063-.333 1.28-.85l20.94-49.723a1.388 1.388 0 00-.74-1.817zm-8.002 10.773s.135-.918-.123-1.307a1.384 1.384 0 00-1.157-.62H8.287c-.972 0-1.761-.791-1.761-1.762 0-1.032.791-1.824 1.765-1.824h23.804a1.386 1.386 0 001.157-2.156 1.385 1.385 0 00-1.157-.62H8.291a4.54 4.54 0 00-4.541 4.533v35.607c0 3.956 3.216 7.173 7.17 7.173h2.418c.56 0 1.062-.333 1.278-.85l16.078-38.174z",
                    clipRule: "evenodd"
                })
            })
        ]
    });
}
/* harmony default export */ var Free = (Slowness);

;// CONCATENATED MODULE: ./src/components/bestrounduplawyers/parkinson/icons/justice.tsx


function Justice() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        fill: "none",
        viewBox: "0 0 60 60",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_0_75",
                style: {
                    maskType: "alpha"
                },
                width: "60",
                height: "60",
                x: "0",
                y: "0",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M0 0H60V60H0z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "#356E3F",
                mask: "url(#mask0_0_75)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M40.815 49.5H4.184c-.71 0-1.185.514-1.185 1.286v6.428c0 .772.474 1.286 1.185 1.286h36.63c.71 0 1.185-.514 1.185-1.286v-6.428c0-.772-.593-1.286-1.185-1.286z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M59.644 52.444L33.519 26.319l3.681-3.681 1.781 1.781c.237.237.594.356.831.356.238 0 .594-.119.832-.356l4.631-4.631c.237-.238.356-.475.356-.832 0-.356-.119-.593-.356-.83L29.006 1.855a1.148 1.148 0 00-1.662 0l-4.632 4.632a1.148 1.148 0 000 1.662l1.781 1.781-13.062 13.063-1.78-1.782a1.148 1.148 0 00-1.663 0l-4.632 4.632a1.148 1.148 0 000 1.662l16.27 16.27c.236.236.593.355.83.355.238 0 .594-.118.832-.356l4.631-4.631c.237-.237.356-.475.356-.831 0-.357-.119-.594-.356-.832l-1.781-1.78 3.681-3.682 26.125 26.125c.237.237.593.356.83.356.238 0 .594-.119.832-.356l4.038-4.038c.237-.237.356-.475.356-.831s-.12-.594-.357-.831z"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var justice = (Justice);

// EXTERNAL MODULE: ./src/components/bestrounduplawyers/parkinson/style.module.scss
var style_module = __webpack_require__(52184);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/shared/scrollToTop/index.tsx
var scrollToTop = __webpack_require__(76105);
;// CONCATENATED MODULE: ./src/components/bestrounduplawyers/parkinson/index.tsx






function Parkinson() {
    const list = [
        {
            title: "Fill Out Our Quick Form",
            body: "Within hours a member of our team will contact you to start the process.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Form, {})
        },
        {
            title: "Get Your Free Legal Consultation",
            body: "We will walk you through all the information you need to determine your damages and eligibility.\xa0 All of your questions will be answered in detail.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Free, {})
        },
        {
            title: "Get the Justice You Deserve",
            body: "You'll be matched with a team of experienced attorneys who have won millions in damages for Roundup lawsuits. They'll be there to support you every step of the way.",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(justice, {})
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "mt-[100px] mx-auto text-2xl md:text-4xl font-bold ",
                    style: {
                        color: "#0a6938"
                    },
                    children: "Legal Help Advisor Process"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (style_module_default()).wrapper,
                children: list.map((item, index)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (style_module_default()).item,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (style_module_default()).index,
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: item.icon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: item.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: item.body
                            })
                        ]
                    }, item.title);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex w-full mb-[100px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollToTop/* default */.Z, {
                    colors: {
                        bg: "#ff7d06",
                        text: "#fff"
                    },
                    className: "mx-auto rounded",
                    children: "Get My Free Lawsuit Case Review"
                })
            })
        ]
    });
}


/***/ }),

/***/ 76105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ScrollToTop; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function ScrollToTop({ children , className , colors  }) {
    const scrollToTop = ()=>{
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: ()=>scrollToTop(),
        style: {
            backgroundColor: colors?.bg ?? "black",
            color: colors?.text ?? "grey"
        },
        className: `px-8 py-3 hover:opacity-90 transition-opacity ${className ?? ""}`,
        children: children
    });
}


/***/ }),

/***/ 52184:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","wrapper":"style_wrapper__oDm9w","item":"style_item__2F6os","index":"style_index__1jpmy"};

/***/ })

}]);